var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcmicrosoft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_754_18980)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.25 11.75H24.5V1.25C24.5 0.836 24.164 0.5 23.75 0.5H13.25V11.75Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 11.75V0.5H1.25C0.836 0.5 0.5 0.836 0.5 1.25V11.75H11.75Z",
    fill: "#F44336"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 13.25H0.5V23.75C0.5 24.164 0.836 24.5 1.25 24.5H11.75V13.25Z",
    fill: "#2196F3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 13.25V24.5H23.75C24.164 24.5 24.5 24.164 24.5 23.75V13.25H13.25Z",
    fill: "#FFC107"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_754_18980"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcmicrosoft);
export default __webpack_public_path__ + "static/media/icmicrosoft.072c9d73d6133ccd09bc66e385d4fae2.svg";
export { ForwardRef as ReactComponent };